import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Tag = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.842 6.218a1.977 1.977 0 00-.424-.628A1.99 1.99 0 0020 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 001.41-.582A1.99 1.99 0 0022 17V7c0-.266-.052-.525-.158-.782z",
    key: "k0"
  }));
});
Tag.displayName = 'Tag';
export var TagDimensions = {
  height: 24,
  width: 24
};